import React, { useState, useEffect } from "react";
import styles from "./slider.module.css";
import { SET_PORTAL_SLIDESHOW } from "../../services/actions/portal_actions";
import { useDispatch } from "react-redux";
import productImage from "../../images/product_1.png";
import { useResize } from "../../hooks/use-resize";
import { WIDTH_2 } from "../../utils/constants";


const Slider = ({ images }) => {

  const [currImage, setCurrImage] = useState(images[0]);

  const currWidth = useResize();

  const dispatch = useDispatch();

  useEffect(() => {
    setCurrImage(images[0]);
    // eslint-disable-next-line
  }, [images,]);

  const handleClickImage = (e) => {
    if ((currImage && currImage?.image) &&
    (currWidth > WIDTH_2 )) {
      dispatch({
        type: SET_PORTAL_SLIDESHOW,
        images: images,
        index: images.findIndex(item => item.image === e.target.src)
      });
    }
  }


  const handleClickLeft = () => {
    let index = images.indexOf(currImage) - 1;
    if (index < 0) {
      index = images.length - 1;
    }
    setCurrImage(images[index]);
  }
  const handleClickRight = () => {
    let index = images.indexOf(currImage) + 1;
    if (index >= images.length) {
      index = 0;
    }
    setCurrImage(images[index]);
  }


  return (
    <div className={styles.container}>
      <img className={styles.img}
        src={currImage?.image ? currImage.image : productImage}
        alt={`Изображение № ${images.indexOf(currImage) + 1}`}
        onClick={handleClickImage}
      />
      {images.length > 1 &&
        <div className={styles.controlPanel}>
          <button className={`${styles.button} ${styles.button__left}`} onClick={handleClickLeft}/>
          <ul className={styles.points}>
            {images.map((item, index) => {
              return (
                <li
                  key={index} onClick={() => setCurrImage(item)}
                  className={`${styles.point} ${(item === currImage) && styles.point__active}`}
                ></li>
              );
            })}
          </ul>
          <button className={`${styles.button} ${styles.button__right}`} onClick={handleClickRight}/>
        </div>
      }
    </div>
  )
}

export default Slider;
